import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledMaintenancePage = styled('div')`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.loginBackgroundColor};
  padding: 24px;

  .content {
    width: 100%;
    max-width: 760px;
    background-color: ${(props) => props.theme.white};
    border-radius: 16px;
    padding: 48px 40px;
    text-align: center;
    color: ${(props) => props.theme.darkGrayishBlue};
  }

  .code {
    margin: 0 0 12px;
    font-size: 42px;
    font-weight: 700;
    line-height: 1.2;
  }

  .description {
    margin: 0;
    font-size: 20px;
    line-height: 1.6;
  }

  .subtitle {
    margin: 20px 0 0;
    font-size: 20px;
    line-height: 1.6;
    font-weight: 500;
  }

  @media only screen and (max-width: ${breakpoints.sm}px) {
    padding: 16px;

    .content {
      padding: 32px 20px;
      border-radius: 12px;
    }

    .code {
      font-size: 2rem;
    }

    .description,
    .subtitle {
      font-size: 1rem;
      line-height: 1.5;
    }
  }
`;
